<form [formGroup]="contactForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
    <div class="left-column">
        <mat-form-field>
            <mat-label>Name der Kontaktperson</mat-label>
            <input matInput [formControl]="contactName" pattern="^[0-9A-Za-zÀ-ÿ\s,._+;()*~'#@!?:&-]+$" (blur)="trimField('contactName')" required />
            <mat-error *ngIf="contactName.invalid && contactName.touched">Bitte einen Namen angeben</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Anrede</mat-label>
            <mat-select [formControl]="gender">
                <mat-option *ngFor="let gender of genders" [value]="gender.value">{{ gender.label }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Telefonnummer</mat-label>
            <input matInput [formControl]="phoneNumber" (blur)="checkAndSetPhonenumber(false)" />
            <mat-error *ngIf="phoneNumber.invalid && phoneNumber.value">
                Bitte eine gültige Telefonnummer angeben
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Mobiltelefonnummer</mat-label>
            <input matInput [formControl]="mobilePhoneNumber" (blur)="checkAndSetPhonenumber(true)" />
            <mat-error *ngIf="mobilePhoneNumber.invalid && mobilePhoneNumber.value">
                Bitte eine gültige Mobiltelefonnummer angeben
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>E-Mail</mat-label>
            <input matInput [formControl]="email" pattern="[^@]+@[^@]+\.[^@]+" (blur)="trimField('email')" required />
            <mat-error *ngIf="email.invalid && email.touched">
                Bitte eine valide E-Mail angeben
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Website</mat-label>
            <input matInput type="url" [formControl]="website" pattern="[\w\düöä-]+[.][\w]+" (blur)="trimField('website')"/>
            @if (website.hasError('websiteLength')) {
                <mat-error>
                    Die Website darf maximal 60 Zeichen lang sein
                </mat-error>
            }
            @if (website.hasError('invalidUrl') && !website.hasError('websiteLength')) {
                <mat-error>
                    Bitte eine valide Website angeben
                </mat-error>
            }
        </mat-form-field>
        <div class="button-container left-column">
            <button *ngIf="!contactInput" matButton="elevated" class="green-confirm" type="submit"
                [disabled]="contactForm.invalid">
                Kontakt speichern
            </button>
            <button *ngIf="contactInput" matButton="elevated" color="warn" (click)="onCancel()">Abbrechen</button>
            <button *ngIf="contactInput" matButton="elevated" class="green-confirm" type="submit"
                [disabled]="contactForm.invalid">
                Speichern
            </button>
        </div>
    </div>
</form>